import React, { createRef, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Button from "core/Button";
import { StyledAttributionText } from "./styles";

import { convertPxToRem } from "frontend/components/helpers";

const UnwrappedAttributionText = ({ children, className }) => {
    const text = createRef();

    const copyText = () => {
        text.current.select();
        document.execCommand("copy");
    };

    const adjustHeight = () => {
        text.current.style.height = "1px";
        text.current.style.height = `${text.current.scrollHeight}px`;
    };

    useEffect(() => {
        adjustHeight();
    }, []);

    return (
        <StyledAttributionText
            className={className}
            flexWrap="nowrap"
            justifyContent="space-between"
        >
            <textarea ref={text} value={children} readOnly />

            <Button
                onClick={copyText}
                styleType="outline"
                size="sm"
                width={convertPxToRem({ px: 72 })}
            >
                Copy
            </Button>
        </StyledAttributionText>
    );
};

const AttributionText = styled(UnwrappedAttributionText)``;

AttributionText.propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default AttributionText;
